
export { CollectionName } from "/codebuild/output/src4200748246/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"